module.exports = __webpack_public_path__ + "static/hyperday-88eeaa129d3a2fa372855e725d78c491.png";